import { ApiService } from "@/core/shared/services/ApiService";

import type { PresencePollResponse } from "@/shared/services/PresenceService.types";

export default class PresenceService {
  static poll(ids: number[]): Promise<PresencePollResponse[]> {
    return ApiService.post("/common/creators-online-status", { ids });
  }
}
